import React, { useEffect } from 'react';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import COMPANY_PERMISSIONS_CONTROLLER from '../../controllers/companyPermissions';
import COMPANIES_CONTROLLER from '../../controllers/companies';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import CompanyPermissionsForm from './CompanyPermissionsForm';
import authorize from '../../utils/auth';
import AuthorizedResource from '../authorization/AuthorizedResource';
import { connect } from 'react-redux';
import Logger, { ALL_MESSAGES, LOG_LEVELS } from '../../utils/logger';
import { SBreadcrumbs } from '@avalara/skylab-sdk/react';

const FORM_NAME = "EDIT_COMPANY_PERMISSIONS";
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);

export const EditCompanyPermissions = (props) => {
    let userId = props?.location?.state?.userId;
    let user = props?.users?.find(obj => obj.id === userId);
    let userInfo = { id: user?.id, iamUserId: user?.iamUserId, firstName: user?.firstName, lastName: user?.lastName, role: user?.role };

    let currentUser = `${user?.firstName} ${user?.lastName}`;
    const breadcrumbItems = [{
        label: LANGUAGES_CONTROLLER.format(props.languages, "CompanyPermissions_Title"),
        dataRef: "1",
        emitNavEvent: true
    },
    {
        label: currentUser,
        dataRef: "2"
    }];

    const handleNavClick = () => props.history.push('/CompanyPermissions');

    const onEditHandler = (selectedCompanies) => {
        setTimeout(function () {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }, 1000);

        log.clearAllDictionaryErrors();

        const updatedCompanies = Object.assign({}, { companyIds: selectedCompanies });
        const selectedSet = new Set((selectedCompanies || []).map(String));
        const removedCompany = (user?.companyGrants || []).some(id => !selectedSet.has(String(id)));
        const reconcileContext = removedCompany ? {
            iamTenantId: props.iamTenantId,
            iamUserId: userInfo.iamUserId,
            companyGrants: selectedCompanies,
        } : undefined;

        props.onEditCompanyPermissions(props.tenantId, userInfo.id, updatedCompanies, () => {
            log.setDictionaryMessage(ALL_MESSAGES.COMPANY_PERMISSION_UPDATE_SUCCESS);
            props.doReloadCompanies();
        }, () => {
            log.setDictionaryMessage(ALL_MESSAGES.COMPANY_PERMISSION_UPDATE_ERROR);
        }, reconcileContext);
    };

    useEffect(() => {
        if (!props.users || !userId) {
            props.history.push('/CompanyPermissions');
        }
    }, [props.users, props.history, userId]);

    useEffect(() => {
        return () => {
            log.clearAllDictionaryErrors();
        }
    }, []);

    return (
        <div className="content-area">
            <s-container data-testid="edit-comp-perm">
                <SBreadcrumbs data-testid="navigation-breadcrumbs" navItems={breadcrumbItems} navHandler={handleNavClick}></SBreadcrumbs>
                <h1 data-testid="edit-comp-perm-header" ><LanguageStringResolver string='EditCompanyPermissions_EditTitle' /></h1>
                <ApplicationMessages messageType="applicationError" messageIds={[ALL_MESSAGES.COMPANY_PERMISSION_UPDATE_ERROR]} />
                <ApplicationMessages messageType="applicationSuccess" messageIds={[ALL_MESSAGES.COMPANY_PERMISSION_UPDATE_SUCCESS]} />

                <CompanyPermissionsForm
                    user={userInfo}
                    editHandler={onEditHandler}
                    selectedCompanies={user?.companyGrants || []}
                    allCompanies={props?.allCompanies}
                />
            </s-container>
        </div>
    );
}

function mapDispatchersToProps(dispatch) {
    return {
        onEditCompanyPermissions: (tenantId, userId, updatedCompanies, successHandler, errorHandler, reconcileContext) => {
            dispatch(COMPANY_PERMISSIONS_CONTROLLER.doEdit(tenantId, userId, updatedCompanies, successHandler, errorHandler, reconcileContext));
        },
        doReloadCompanies: () => {
            dispatch(COMPANIES_CONTROLLER.doLoadCompaniesSummary());
        }
    }
}

export function mapStateToProps(state) {
    return {
        users: state.companyPermissions?.data,
        allCompanies: state.companyPermissions?.allCompanies,
        tenantId: state.authentication && state.authentication.data && state.authentication.data.customerId,
        iamTenantId: state.authentication?.data?.iamData?.tenantId
    };
}

export default authorize({
    name: 'EditCompanyPermissions',
    resource: connect(mapStateToProps, mapDispatchersToProps)(EditCompanyPermissions)
},
    AuthorizedResource, {
    showNotAuthorized: true
});
